(function () {
  angular
    .module("akitabox.desktop.workOrder.detail")
    .controller("WorkOrderAssetTabController", WorkOrderAssetTabController);

  /* @ngInject */
  function WorkOrderAssetTabController(
    $timeout,
    building,
    workOrder,
    AssetService,
    ToastService,
    WorkOrderService
  ) {
    var self = this;

    // Attributes
    self.loading = true;
    self.rendering = true;
    self.building = building;
    self.workOrder = workOrder;
    self.asset = true;

    init();

    function init() {
      var assetId = WorkOrderService.getAsset(workOrder)._id;
      var params = { include_values: true };
      var options = {
        includePinType: true,
        includeFloor: true,
        includeRoom: true,
      };
      AssetService.getById(building._id, assetId, params, options)
        .then(function (asset) {
          self.asset = asset;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
          $timeout(function () {
            self.rendering = false;
          }, 500);
        });
    }
  }
})();
